/**
 * Custom "Me" icon — a four-pointed compass star.
 * Represents: you are here, everything radiates from you.
 * Distinct from Users (people silhouettes) — this is a singular point of origin.
 */
export function MeIcon({
  size = 24,
  strokeWidth = 1.5,
  className,
  style,
}: {
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
    >
      {/* Four-pointed star — compass/north star */}
      <path d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z" />
      {/* Center dot — you are here */}
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}
